import React from 'react'
import vetmed1 from '../Images/vetmedban.jpg'
import '../Cardpage.css'
function VeterineryMed() {
  return (
    <>
    <div className='cardpagediv'>
      <h3 className='cardpagehead'>Veterinery Medicines</h3>
      <img src={vetmed1} className='w-100 imgbanner' alt="" />
    </div>
    <p className='cardpagepara1 ms-2 me-2'>
      We have a well established veterinary store with all kind of veterinery medicines available.
    </p>
    <h5 className='cardpagehead5'>
      Premium veterinary medicine brands we have :
    </h5>
    <div className='commonpagediv'>
      <div>
    <ul>
      <li>Virbac</li>
      <li>Himalaya</li>
      <li>Intas</li>
      <li>ttk</li>
      <li>MSD</li>
      <li>Elanco</li>
      <li>Zydus</li>
      <li>Alembic</li>
      <li>Zenex</li>
    </ul>
    </div>
    <div>

    </div>
    </div>
    <p className='ms-2 pagebott'>We also have all type of vet suppliments for their better growth and energy. </p>
    </>
  )
}

export default VeterineryMed